import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../utils/withPayloadType';
import { monitorOverviewTab } from '../reducer/monitorOverviewTab';

const initialize = createAction('monitorOverviewTab/initialize', withPayloadType<string>());

const monitorOverviewTabActions = { ...monitorOverviewTab.actions, initialize };

export default monitorOverviewTabActions;
